import useSWR from "swr";
import { type QuizSummary } from "../types";
import { simpleFetcher } from "../fetcher";

const url = "/api/v2/quizzes";

/**
 * Quizzes in the active governance unit, with invited/completed counts
 * (managers only). Pass a release id to get only that release's quiz.
 */
export function useQuizzes(documentReleaseId?: number) {
  const key =
    documentReleaseId === undefined
      ? url
      : `${url}?documentReleaseId=${documentReleaseId}`;

  return useSWR<QuizSummary[], Error>(key, simpleFetcher, {
    // Poll while any quiz is still generating so its row turns into a real quiz
    // on its own; stop once they are all ready.
    refreshInterval: (quizzes) =>
      quizzes?.some((quiz) => quiz.status === "generating") ? 3000 : 0,
  });
}
